import React from "react";
import 'moment-timezone';
import SweetAlert from "react-bootstrap-sweetalert";
import Ticket58 from "../print/ticket58";
import NumberFormat from "react-number-format";
import NewRecentTicketRow from "../../lotto99/bet/NewRecentTicketRow";
import {useLotto90} from "../../../store/lotto90/Lotto90Context";
import RefreshButton from "../../../utils/RefreshButton";

const RecentTicketMobile = () => {
    const {
        onFilter,
        size,
        onChangeSize,
        onShowDetail,
        t,
        tickets,
        isShow,
        onCloseDetail,
        dataDetail,
        imageRotate
    } = useLotto90()
    return (
        <div className="lotto90">
            <div
                className="col no-padding-div header-div-title header-text header-div-blue-light block-header position-static border-b-1 d-flex align-items-center">
                    <span className="text-black kh-font-bold">{t("labels:common.recentBet")}
                        <NumberFormat
                            className="in-recent-size"
                            isAllowed={({value}) => value < 11}
                            onBlur={() => {
                                if (size > 0 && size < 11) onFilter()
                                else onChangeSize(3)
                            }}
                            onValueChange={({floatValue}) => onChangeSize(floatValue)}
                            value={size}/>
                                        <span>
                                            {t("labels:common.draw")}
                                        </span>
                                </span>

                <div className="d-flex align-item-center mr-2">
                    <RefreshButton
                        onClick={() => onFilter()}
                        className={imageRotate}
                    />
                </div>
            </div>
            <NewRecentTicketRow onShowDetail={onShowDetail} t={t} tickets={tickets}/>

            <SweetAlert
                title=""
                show={isShow}
                onConfirm={onCloseDetail}
                confirmBtnText={t("labels:common.close")}
                showCancel={false}
                btnSize="lg"
            >
                <div id="ticket-lo-90-mobile" className='d-flex justify-content-center'>
                    <Ticket58
                        object={dataDetail}/>
                </div>
            </SweetAlert>

        </div>
    );
}

export default RecentTicketMobile
